import { createSelector } from 'reselect'
 
export const selectHeaderTabDS =state=>state.headerReducer?.headerTab
export const selectTransmissionType =state=>selectHeaderTabDS(state)?.transmissionType
export const selectProcedure =state=>selectHeaderTabDS(state)?.procedure
export const selectDeclType =state=>selectHeaderTabDS(state)?.declType
export const selectDeclaration =state=>selectHeaderTabDS(state)?.declaration
export const selectCircuit =state=>selectHeaderTabDS(state)?.circuit
export const selectObservation =state=>selectHeaderTabDS(state)?.observation
export const selectBorderModeDS=state=>state.transportReducer.borderTransportMode;
export const selectCountryInfoDS=state=>state.transportReducer.countryInfo;
export const selectOriginCountry=state=>selectCountryInfoDS(state)?.originCountry
export const selectDeclarationList=state=>state.dropDownReducer.declaration
export  const selectDeclarationTypeList=state=>state.dropDownReducer.declarationType
export const selectAuthTypeList=state=>state.dropDownReducer.headerAuthorisationType
export const selectAuthTypeListItems=state=>state.dropDownReducer.authorisationType
export const selectWarehouseDS=state=>state.transportReducer.warehouse
export const selectTransmissionTypeList=state=>state.dropDownReducer.transmissionType
//export const selectCountryList=state=>state.dropDownReducer.countryCodes
export const selectStateProvList=state=>state.dropDownReducer.destinationProvince
export const selectSupplyChainRoleList=state=>state.dropDownReducer.supplyChainActorRole
export const selectSupplyChainOwnerList=state=>state.dropDownReducer.supplyChainActorOwner
export const selectMotList=state=>state.dropDownReducer.transportMode
export const selectSecurityList=state=>state.dropDownReducer.security
export const selectPaymentList=state=>state.dropDownReducer.methodOfPayment
export const selectSpecialCircumstancesList=state=>state.dropDownReducer.specialcircumstances
export const selectCustomOfficeList=state=>state.dropDownReducer.customOffice
export const selectSpecialCountryList=state=>state.dropDownReducer.specialCountryKeys
export const selectMotTypeList=state=>state.dropDownReducer.transportMean
export const selectLocationOfGoodsDS=state=>state.transportReducer.locationOfGoods
export const selectGoodsLocationType=state=>state.dropDownReducer.goodsLocationType
export const selectCancelReasonList=state=>state?.dropDownReducer?.cancelReasonList
export const selectCustomOfficeTypeList=state=>state.dropDownReducer.customOfficeType
export const selectexemptedCodeList=state=>state.dropDownReducer.TARRIF_EXEMPT_DOC_LIST_FROM_DELETE

export const selectActiveTranTypeList = createSelector(
    [selectMotTypeList],
    (motList) => {
      return motList?.filter(c=>c.additionalInfo=="active")
    }
);
export const selectIncoTermsList = state=>state.dropDownReducer.incoterms
export const selectCurrencyCodesList = (state) => state.dropDownReducer.currencyCodes
export const selectAdditionalRefTypeList = (state) => state.dropDownReducer.additionalRefType
export const selectPreviousDocTypeList = (state) => state.dropDownReducer.previousDocType
export const selectDispatchRegionList = (state) => state.dropDownReducer.dispatchRegion
export const selectpreferencesList = (state) => state.dropDownReducer.preferences
export const selectPreviousProcedureList = (state) => state.dropDownReducer.previousProcedure
export const selectDestinationProvinceList = (state) => state.dropDownReducer.destinationProvince
export const selectMeasurementUnitList = (state) => state.dropDownReducer.measurementUnit
export const selectTransactionNatureList = (state) => state.dropDownReducer.transactionNature
export const selectSupportingDocumentList = (state) => state.dropDownReducer.supportingDocument
export const selectAdditionalProcedureList = (state) => state.dropDownReducer.additionalProcedure
export const selectPackageCodesList = (state) => state.dropDownReducer.packageCodes
export const selectQualifierList=state=>state.dropDownReducer.qualifier
export const selectAdditionalInfoCodesList = (state) => state.dropDownReducer.additionalInfoCodes
export const selectAdditionalInfoCodes2List = (state) => state.dropDownReducer.additionalInfoCodes2


  // NL
  export const selectProcedureList=state=>state.dropDownReducer.procedure
  export const selectCountryList=state=>state.dropDownReducer.countryList
  export const selectTerminalList=state=>state.dropDownReducer.terminal
  export const selectBorderTransportMeanList=state=>state.transportReducer.borderTransportMeansList
  export const selectBorderMot=state=>selectBorderTransportMeanList(state)[0]?.modeOfTransport
  export const selectAdditionalDocList=state=>state.dropDownReducer.additionalDocs
  export const selectPaymentTypeList=state=>state.dropDownReducer.partiesPaymentTypes
  export const selectPaymentRoleList=state=>state.dropDownReducer.partiesPaymentRolesVAT
  export const selectGuaranteeTypeList=state=>state.dropDownReducer.partiesGuaranteeType
  export const selectTaxTypeList = (state) => state.dropDownReducer.taxType
  export const selectCostTypeList = (state) => state.dropDownReducer.costType
  export const selectValuationMethodList = (state) => state.dropDownReducer.valuationMethod
  export const selectArrivalTransportDS=(state) => state.transportReducer.arrivalTransportMeansList
  export const selectDepartureTransportDS=(state) => state.transportReducer.departureTransportMeansList
  export const selectArrivalTransportLength=(state) =>selectArrivalTransportDS(state).length
  export const selectRepresentationList=(state)=>state.dropDownReducer.representations
  export const selectEconomicCustomList=(state)=>state.dropDownReducer.customOfficeDms
  export const selectExitInfoList=(state)=>state.dropDownReducer.exitInfo
  // NL end
